import React from 'react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FooterLinks } from '../index';

const useStyles = makeStyles((theme: Theme) => ({
  footerLinks: {
    textAlign: 'center',
    marginBottom: theme.spacing(1)
  }
}));

const FooterLinksSection = (): React.ReactElement => {
  const classes = useStyles();

  return (
    <div className={classes.footerLinks}>
      <FooterLinks />
    </div>
  );
};

export default FooterLinksSection;
